<template>
  <div class="main-container">
    <!-- 头部栏 -->
    <HomeHeader tabIndex="4" />
    <!-- 内容 -->
    <div class="container">
      <div class="title">公司历程</div>
      <p>集友科技创新(深圳)有限公司成立于2020年9月21日，由香港集友银行在深圳设立的中国大陆首家港资银行全资控股的金融科技公司，成为厦门国际银行控股的集团成员之一。公司将发挥集团科技优势，整合集团金融科技能力、资源和成果，践行“科技引领”战略定位,致力于将公司打造为集友银行乃至厦门国际银行集团金融科技发展的重要平台。</p>
      <p>2020年6月，经市委市政府、市金管局、福田区委区政府、金融科技协会支持，获批成功入驻深圳新一代产业园，深圳新一代产业园是深圳首个以“5G研发及应用”产业主导的高端创新产业园区，是深圳市首批5G信号覆盖示范园区，是深港科技创新合作1+N模式的首个卫星园区，集聚创意，创新元素环境，并以“三个龙头、两个生态”思路打造产业+商业+科技+创意+学习+生活全息服务场景，开创科技创新新篇章。</p>
      <p>公司将继续依托并整合集团金融+技术的优势,聚焦中小商业银行、产业互联网客群，在中小银行金融科技规划、IT系统整体架构规划、IT运维及数据中心服务、网络安全与业务连续性、银行科技项目群管理、金融科技业务创新等领域形成具有核心竞争力的金融产品解决方案与服务能力，前瞻布局产业互联网金融、跨境金融等金融科技领域，以市场化、独立化的管理模式打造“金融+科技+生态”的数智化服务，形成差异化竞争优势，为集团及客户实现科技赋能。</p>
      <img class="bottom-img" :src="contentBg" />
    </div>
    <!-- 底部栏 -->
    <HomeFooter />
  </div>
</template>

<script>
import HomeHeader from '@/components/HomeHeader.vue'
import HomeFooter from '@/components/HomeFooter.vue'
export default {
  name: 'history',
  components: { HomeHeader, HomeFooter },
  data () {
    return {
      contentBg: require('@/assets/images/body_bg.png')
    }
  }
}
</script>

<style scoped lang="less">
  .main-container {
    .container {
      position: relative;
      margin: auto;
      width: 800px;
      min-height: calc(100vh - 200px);
      padding-bottom: 300px;
      box-sizing: border-box;
    }
    .title {
      padding: 30px 0 10px;
      font-size: 32px;
      text-align: center;
    }
    p {
      font-size: 18px;
      text-indent: 2em;
      text-align: justify;
    }
    .team-img {
      margin-left: 25%;
      width: 50%;
    }
    .bottom-img {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
    }
  }
</style>